import React from "react";
import { ExpressionView, ExpressionViewEmptyBehavior } from "../ExpressionView";
import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";

import { getFilledDataDefinition } from "../../rule-engine-core/Common/Data/DataTestData";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { ObjectDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { Box } from "@mui/material";

export const ExpressionViewStories = [
    new StoryNode(
        () => {
            return (
                <ExpressionView
                    expression={new ExpressionConfiguration()}
                    openFirstTimeWhenEmptyExpression={false}
                ></ExpressionView>
            );
        },

        "Expression Builder",
        "Expression View",
        "Empty",
        "Empty - do not open edit layer",
    ),
    new StoryNode(
        () => {
            let dataDefinition = getFilledDataDefinition();
            let exp = new ExpressionConfiguration();
            exp.inputData = dataDefinition;

            return (
                <ExpressionView
                    expression={exp}
                    openFirstTimeWhenEmptyExpression={true}
                ></ExpressionView>
            );
        },

        "Expression Builder",
        "Expression View",
        "Empty",
        "Empty - open edit layer",
    ),

    new StoryNode(
        () => {
            let dataDefinition = getFilledDataDefinition();
            let exp = new ExpressionConfiguration();
            exp.executionResult = new StringDataDefinition();
            exp.inputData = dataDefinition;

            return (
                <ExpressionView
                    expression={exp}
                    openFirstTimeWhenEmptyExpression={true}
                ></ExpressionView>
            );
        },

        "Expression Builder",
        "Expression View",
        "Empty",
        "String Result",
    ),

    new StoryNode(
        () => {
            let dataDefinition = getFilledDataDefinition();
            let exp = new ExpressionConfiguration();
            exp.executionResult = new StringDataDefinition();
            exp.inputData = dataDefinition;

            return (
                <Box width={"200px"}>
                    <ExpressionView
                        emptyBehavior={ExpressionViewEmptyBehavior.VALUE}
                        expression={exp}
                        openFirstTimeWhenEmptyExpression={true}
                    ></ExpressionView>
                </Box>
            );
        },

        "Expression Builder",
        "Expression View",
        "Value First",
    ),

    new StoryNode(
        () => {
            let dataDefinition = getFilledDataDefinition();
            let exp = new ExpressionConfiguration();
            exp.executionResult = new StringDataDefinition();
            exp.inputData = dataDefinition;

            return (
                <Box width={"200px"}>
                    <ExpressionView
                        emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                        expression={exp}
                        openFirstTimeWhenEmptyExpression={true}
                    ></ExpressionView>
                </Box>
            );
        },

        "Expression Builder",
        "Expression View",
        "Variable First",
    ),

    new StoryNode(
        () => {
            let dataDefinition = getFilledDataDefinition();
            let exp = new ExpressionConfiguration();
            exp.executionResult = new StringDataDefinition();
            exp.inputData = dataDefinition;

            return (
                <Box width={"200px"}>
                    <ExpressionView
                        emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                        expression={exp}
                        label={"Label"}
                        openFirstTimeWhenEmptyExpression={true}
                    ></ExpressionView>
                </Box>
            );
        },

        "Expression Builder",
        "Expression View",
        "Variable First (label)",
    ),

    new StoryNode(
        () => {
            let dataDefinition = getFilledDataDefinition();
            let exp = new ExpressionConfiguration();
            let odd = new ObjectDataDefinition();
            odd.fields = [
                new StringDataDefinition("name"),
                new StringDataDefinition("address"),
                new NumberDataDefinition("age"),
            ];
            exp.executionResult = odd;
            exp.inputData = dataDefinition;

            return (
                <ExpressionView
                    expression={exp}
                    openFirstTimeWhenEmptyExpression={true}
                ></ExpressionView>
            );
        },

        "Expression Builder",
        "Expression View",
        "Empty",
        "Object Result",
    ),
];
